import moment from "moment";
import React, { useMemo} from "react";
import { FaCheckCircle } from "react-icons/fa";
import { calcOrderTotal, convertCurrency, convertPriceWithCommission, imageRender, numberFormat, thousandSeperate } from "../../../helpers";

const OrderGroupDetail = ({ orderData, setSecondStep, taxPrice, shopRate, isPaymented }) => {
  const rate = useMemo(() => {
    if (shopRate) {
      return shopRate;
    }
    return {}
  }, [shopRate]);
  console.log(orderData);
  // ສູດຢູ່ helper ເພາະແຖບລຸ່ມກໍ່ຕ້ອງໃຊ້ຄ່າດຽວກັນ
  const sumPriceTotal = useMemo(
    () => calcOrderTotal({ orderData, taxPrice, shopRate: rate }),
    [orderData, rate, taxPrice]
  );

  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: 16 }}>
      {/* <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
          <div style={{ fontWeight: 'bold', marginRight: 5 }}>{"ລາຍລະອຽດສັ່ງຊື້"}</div>
          <div>{orderData?.code}</div>
        </div> */}
      {/* ຕອນຍັງບໍ່ຊຳລະ ປ້າຍກະພິບຍ້າຍໄປຢູ່ header ຂ້າງ chip "ຢືນຢັນອໍເດີ" ແລ້ວ */}
      {isPaymented && (
        <div className="cf-banner cf-banner--success" style={{ width: '100%' }}>
          <FaCheckCircle className="cf-banner__icon" aria-hidden="true" />
          <span>ຂອບໃຈ ທ່ານລູກຄ້າຊຳລະອໍເດີ (Thank you for your order)</span>
        </div>
      )}

      <div className="cf-card cf-rows" style={{ width: '100%' }}>
        <div className="cf-row">
          <span className="cf-row__label">ສະຖານະ (Status)</span>
          <span className={`cf-row__value ${isPaymented ? "cf-row__value--paid" : "cf-row__value--unpaid"}`}>
            <span className="cf-status-dot" aria-hidden="true" />
            {isPaymented ? "ຈ່າຍເງິນແລ້ວ" : "ຍັງບໍ່ຈ່າຍເງິນ"}
          </span>
        </div>
        <div className="cf-row">
          <span className="cf-row__label">ເລກທີບິນ (Invoice)</span>
          <span className="cf-row__value">{orderData?.code}</span>
        </div>
        <div className="cf-row">
          <span className="cf-row__label">ວັນທີ່ສັ່ງຊື້ (Date)</span>
          <span className="cf-row__value">{moment(orderData?.createdAt).format('DD/MM/YYYY HH:mm')}</span>
        </div>
      </div>

      <div className="cf-section-label" style={{ width: '100%' }}>ລາຍການສິນຄ້າ (Order Items)</div>

      <div className="cf-items" style={{ width: '100%' }}>
        {orderData?.orders?.map((order, index) => (
          <div className="cf-item" key={index}>
            <img
              className="cf-item__thumb"
              src={imageRender(order?.liveStock?.stock?.image?.[0] ?? order?.postStock?.stock?.image?.[0] ?? order?.stock?.image?.[0])}
              alt=""
            />
            <div className="cf-item__body">
              <div className="cf-item__name">
                {order?.productName}{order?.cfMessage ? ` (${order?.cfMessage})` : ""}
              </div>
              <div className="cf-item__meta">
                {thousandSeperate(order?.price)} {order?.currency} x{order?.amount}
              </div>
            </div>
            <div className="cf-item__total">
              {thousandSeperate(order?.price * order?.amount ?? 0)} {convertCurrency(order?.currency)}
            </div>
          </div>
        ))}
      </div>
      <div className="cf-section-label" style={{ width: '100%' }}>ຍອດລວມທັງໝົດ (Total)</div>

      <div className="cf-card cf-rows" style={{ width: '100%' }}>
        {orderData?.totalPrice > 0 && (
          <div className="cf-row">
            <span className="cf-row__label">ລວມເງິນກີບ</span>
            <span className="cf-row__value">₭{thousandSeperate(orderData?.totalPrice)}</span>
          </div>
        )}
        {orderData?.sumPriceBaht > 0 && (
          <div className="cf-row">
            <span className="cf-row__label">ລວມເງິນບາດ</span>
            <span className="cf-row__value">฿{thousandSeperate(orderData?.sumPriceBaht)}</span>
          </div>
        )}
        {orderData?.sumPriceUsd > 0 && (
          <div className="cf-row">
            <span className="cf-row__label">ລວມເງິນໂດລາ</span>
            <span className="cf-row__value">${thousandSeperate(orderData?.sumPriceUsd)}</span>
          </div>
        )}
        {taxPrice > 0 && (
          <div className="cf-row">
            <span className="cf-row__label">ຄ່າບໍລິການ</span>
            <span className="cf-row__value">₭{numberFormat(taxPrice ?? 0)}</span>
          </div>
        )}
        <div className="cf-row cf-total--grand">
          <span className="cf-row__label">ເງິນທີ່ຕ້ອງຊຳລະຕົວຈິງ</span>
          <span className="cf-row__value">{numberFormat(sumPriceTotal)}₭</span>
        </div>
      </div>

    </div>
  );
};

export default OrderGroupDetail;
